module.exports = "/dist/76da3d414f13d49edbca71dbf32c07d7.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100.eot
// module id = 6
// module chunks = 0